import BlockNumberText from '..';
import './index.less';
export default function BlockNumberTextMobile(): JSX.Element {
  return (
    <div className="syn-block-number-text-mobile">
      <BlockNumberText />
    </div>
  );
}
